import { render } from "./icon-component.vue?vue&type=template&id=0224f13f&ts=true"
import script from "./icon-component.vue?vue&type=script&lang=ts"
export * from "./icon-component.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__